<ng-container>
  <form [formGroup]="jobFilterForm">

    <div class="row">

      <ngb-accordion [activeIds]="'custom-panel-1'" *ngIf="!hideJobSource">
        <ngb-panel id="custom-panel-1">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Job Source</span>
                <span [ngClass]="getBadgeClass(getJobSourceCount())" *ngIf="getJobSourceCount() > 0">
                  {{getJobSourceCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12" formArrayName="source">
              <div *ngFor="let jobs of jobSourcesFormarray.controls; let i=index">
                <div [formGroupName]="i" class="row">

                  <div class="col-sm-6" *ngIf="!orgJobsMode">
                    <div class="custom-checkbox" title="Search All filters">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="all" (change)="jobSoucecheck($event,'all')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> All</p>
                      </label>
                    </div>
                  </div>

                  <div class="col-sm-6" *ngIf="!orgJobsMode">
                    <div class="custom-checkbox" title="Search jobs from gigsumo platform">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="marketPlaceJobs"
                          (change)="jobSoucecheck($event,'marketPlaceJobs')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp">Marketplace</p>
                      </label>
                    </div>
                  </div>

                  <div class="col-sm-6" *ngIf="owner || orgJobsMode">
                    <div class="custom-checkbox" title="Search My Job">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="myJobs" (change)="jobSoucecheck($event,'myJobs')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> My Jobs</p>
                      </label>
                    </div>
                  </div>

                  <!-- SuperAdmin org-scoped view: My Employees toggles the employee picker below -->
                  <div class="col-sm-6" *ngIf="orgJobsMode">
                    <div class="custom-checkbox" title="Filter by jobs posted by selected employees">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="myEmployees" (change)="jobSoucecheck($event,'myEmployees')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> My Employees</p>
                      </label>
                    </div>
                  </div>

                  <ng-container *ngIf="!filterApplied && !orgJobsMode">
                    <div class="col-sm-6" *ngFor="let filterItem of personalNetworks">
                      <div class="custom-checkbox">
                        <label class="checkbox-label font-normal">
                          <input type="checkbox" [formControlName]="filterItem?.key"
                            (change)="jobSoucecheck($event, filterItem?.key , 'personalNetworks')"/>
                          <span class="checkmark" style="top: -5px"></span>
                          <p class="label-ppp"> {{ filterItem?.networkName }}</p>
                        </label>
                      </div>
                    </div>
                  </ng-container>

                  <div class="col-sm-6" *ngIf="!orgJobsMode && !filterApplied && userType!='JOB_SEEKER'">
                    <div class="custom-checkbox" title="Search Workspace Jobs">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="teamJobs" (change)="jobSoucecheck($event,'teamJobs')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Workspace Jobs</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!orgJobsMode">
                    <div class="custom-checkbox">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="memberNetworksJobs"
                        (change)="jobSoucecheck($event,'memberNetworksJobs')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Member Network</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!orgJobsMode && userType != 'JOB_SEEKER' && businessNetworkData?.length > 0">
                    <div class="custom-checkbox">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="businessNetwork"
                        (change)="jobSoucecheck($event,'businessNetwork')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Business Network</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="!orgJobsMode && userType != 'JOB_SEEKER' && membershipType !== 'Free'">
                    <div class="custom-checkbox">
                      <label class="checkbox-label font-normal">
                        <input type="checkbox" formControlName="eligibleSubContractJobs"
                        (change)="jobSoucecheck($event,'eligibleSubContractJobs')" />
                        <span class="checkmark" style="top: -5px"></span>
                        <p class="label-ppp"> Sub-Contracting</p>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 p-0">

                    <div class="col-sm-12" *ngIf="!orgJobsMode">
                         <app-customer-filter-template
                          [filterData]="publishedByList | async"
                          [asyncSearch]="true"
                          [title]="'Published By'"
                          [resetFilter]="jobFilterForm.get('resetFilter').value"
                          [searchResult]="publishedPayload?.personalNetworks?.length > 0 && ['Personal Networks'] "
                          [this]="this"
                          [panelName]="(publishedPayload?.personalNetworks?.length > 0) ? 'custom-panel-1' : ''"
                          [filterKey]="'fullName'"
                          [filterCount]="getPublishedByCount()"
                          [isLoading]="publishedByLoading"
                          [loaderKey]="'publishedByLoading'"
                          (onSearch)="onPublishSearch($event)"
                          (onSelect)="onSelectChange($event , 'selectedPublishedBy')"
                          (onScroll)="onPublishScroll($event)"
                        >
                        </app-customer-filter-template>
                    </div>

                    <div class="col-sm-12" *ngIf="!orgJobsMode && jobSourcesFormarray.at(0).get('businessNetwork').value && businessNetworkData?.length > 0">
                        <app-customer-filter-template
                        [title]="'Business Networks'"
                        [filterData]="businessNetworkData"
                        [filterKey]="'b2bNetworkName'"
                        [resetFilter]="jobFilterForm.get('resetFilter').value"
                        [panelName]="jobSourcesFormarray.at(0).get('businessNetwork').value ? 'custom-panel-1' : ''"
                        [showFilter]="true"
                        [loaderKey]="'isLoading'"
                        [filterCount]="getBusinessNetworkCount()"
                        (onSelect)="onSelectChange($event , 'selectedBusinessNetworks')"
                        [this]="this"
                        >
                        </app-customer-filter-template>
                    </div>

                    <div class="col-sm-12" *ngIf="!orgJobsMode && (businessNetworkData?.length > 0  || (userType === 'JOB_SEEKER' || membershipType === 'Free' || membershipType === 'Pro') || jobSourcesFormarray.at(0).get('eligibleSubContractJobs').value)">
                        <app-customer-filter-template
                        [filterData]="customersList | async"
                        [asyncSearch]="true"
                        [this]="this"
                        [title]="'Customer'"
                        [resetFilter]="jobFilterForm.get('resetFilter').value"
                        [searchResult]="memberAvailable ? ['Member Networks'] : ['Business Networks' , 'Member Networks' ]"
                        [panelName]="(selectedBusinessNetworks?.length > 0 || jobSourcesFormarray.at(0).get('businessNetwork').value || jobSourcesFormarray.at(0).get('memberNetworksJobs').value || jobSourcesFormarray.at(0).get('eligibleSubContractJobs').value) ? 'custom-panel-1' : ''"
                        [filterKey]="'businessName'"
                        [filterCount]="getCustomerCount()"
                        [isLoading]="customerLoading"
                        [loadingMore]="customerLoadingMore"
                        [loaderKey]="'customerLoading'"
                        (onSearch)="onCustomerSearch($event)"
                        (onSelect)="onSelectChange($event , 'selectedCustomers')"
                        (onScroll)="onCustomerScroll($event)"
                        >
                        </app-customer-filter-template>
                    </div>

                    <!-- SuperAdmin org-scoped view: employee picker. Title is
                         "Published By" to stay consistent with the rest of the
                         platform (the underlying field on a job is jobPostedBy);
                         the trigger checkbox above is "My Employees". -->
                    <div class="col-sm-12" *ngIf="orgJobsMode && (jobSourcesFormarray.at(0)?.get('myEmployees')?.value || employeeOffShowing)">
                        <app-customer-filter-template
                          [filterData]="employeeList | async"
                          [title]="'Published By'"
                          [resetFilter]="jobFilterForm.get('resetFilter').value"
                          [this]="this"
                          [panelName]="''"
                          [filterKey]="'fullName'"
                          [filterCount]="getEmployeeCount()"
                          [showFilter]="true"
                          [asyncSearch]="true"
                          [isLoading]="employeeLoadingInput || employeeOffLoading"
                          (onSearch)="onEmployeeSearch($event)"
                          (onScroll)="onEmployeeScroll($event)"
                          (onSelect)="onSelectChange($event, 'selectedEmployees')"
                        >
                        </app-customer-filter-template>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </ng-template>


        </ngb-panel>
      </ngb-accordion>




      <!-- <app-customer-filter-template [title]="'Published To'"[filterKey]="'name'" (onSearch)="onPublishSearch($event)"
        (onScroll)="onPublishScroll($event)">
      </app-customer-filter-template> -->


      <ngb-accordion>

        <ngb-panel id="custom-panel-2">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Client Type</span>
                <span [ngClass]="getBadgeClass(getClientTypeCount())" *ngIf="getClientTypeCount() > 0">
                  {{getClientTypeCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div class="custom-checkbox col-sm-6 p-0" title="{{checkbox.label}}"
                *ngFor="let checkbox of clientTypeCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                    (change)="clientTypecheck($event, checkbox.label, 'vertical')" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp">{{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>

        </ngb-panel>

        <ngb-panel id="custom-panel-3">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Status</span>
                <span [ngClass]="getBadgeClass(getStatusCount())" *ngIf="getStatusCount() > 0">
                  {{getStatusCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div [ngClass]="checkbox.disable ? 'hidden' : 'block'" class="custom-checkbox col-sm-6 p-0" title="{{checkbox.label}}"
                *ngFor="let checkbox of statusCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input type="checkbox" name="trades" [checked]="checkbox.selected"
                    (change)="statuscheckbox($event,checkbox.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label}}</p>
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>

        <ngb-panel id="custom-panel-4">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Engagement Type</span>
                <span [ngClass]="getBadgeClass(getJobClassificationCount())" *ngIf="getJobClassificationCount() > 0">
                  {{getJobClassificationCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div class="col-sm-6 p-0"
                *ngFor="let checkbox of jobclasscificationCheckboxes;let i = index; let lastItem = last">
                <div class="custom-checkbox" title=" {{checkbox.label}}">
                  <label class="checkbox-label font-normal">
                    <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                      (change)="jobclassficheckbox($event,checkbox.label)" />
                    <span class="checkmark" style="top: -5px"></span>
                    <p class="label-ppp"> {{ checkbox.label }}</p>
                  </label>
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>

      <ngb-accordion>
        <ngb-panel id="custom-panel-5">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Work Mode</span>
                <span [ngClass]="getBadgeClass(getWorkModeCount())" *ngIf="getWorkModeCount() > 0">
                  {{getWorkModeCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="col-sm-12 p-0">
              <div class="custom-checkbox  col-sm-6" title="{{checkbox.label}}"
                *ngFor="let checkbox of workModeCheckboxes;let i = index; let lastItem = last">
                <label class="checkbox-label font-normal">
                  <input type="checkbox" [disabled]="checkbox.disable" name="trades" [checked]="checkbox.selected"
                  (change)="workModeChange($event.target.checked , checkbox?.label)" />
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{ checkbox.label }}</p>
                </label>
              </div>
            </div>
          </ng-template>

        </ngb-panel>
      </ngb-accordion>

      <ngb-accordion>
        <ngb-panel id="custom-panel-6">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Location</span>
                <span [ngClass]="getBadgeClass(getLocationCount())" *ngIf="getLocationCount() > 0">
                  {{getLocationCount()}}
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div class="row app-form form-group">
                <div class="col-sm-6">
                  <select class="form-control input-sm" formControlName="country" type="text"
                    (change)="onChangeCountry($event.target.value)">
                    <option value="null" selected disabled>
                      Country
                    </option>
                    <option *ngFor="let country of countryList" [value]="country.countryCode">
                      {{ country.countryName }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'US'">
                  <input type="text" maxlength="11" (keypress)="digitKeyOnly($event)" placeholder="Zip Code"
                    formControlName="zipCode" class="form-control input-sm" (keyup)="onKeyZip($event)" />
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'CA'">
                  <select class="form-control input-sm" formControlName="state" type="text"
                    (change)="onChangestate($event.target.value)">
                    <option value="null" selected="true" disabled>
                      State
                    </option>
                    <option *ngFor="let state of stateListCA" [value]="state.stateName">
                      {{ state.stateName }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'IN'">
                  <select class="form-control input-sm" formControlName="state"
                    (change)="onChangestate($event.target.value)" type="text">
                    <option value="null" selected="true" disabled>
                      State
                    </option>
                    <option *ngFor="let state of stateListIN" [value]="state.stateName">
                      {{ state.stateName }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'AU'">
                  <select class="form-control input-sm" formControlName="state"
                    (change)="onChangestate($event.target.value)" type="text">
                    <option value="null" selected="true" disabled>
                      State
                    </option>
                    <option *ngFor="let state of stateListAU" [value]="state.stateName">
                      {{ state.stateName }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6" *ngIf="
                                          jobFilterForm.value.country != 'AU' &&
                                          jobFilterForm.value.country != 'IN' &&
                                          jobFilterForm.value.country != 'CA' &&
                                          jobFilterForm.value.country != 'US'
                                        ">
                  <input type="text" maxlength="50" placeholder="State" formControlName="state"
                    class="form-control input-sm" (change)="onChangestate($event.target.value)" />
                </div>
              </div>
              <div class="row form-group app-form">
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'US'">
                  <input type="text" maxlength="50" disabled placeholder="City" formControlName="city"
                    (change)="onChangecity($event.target.value)" class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country != 'US'">
                  <input type="text" maxlength="50" placeholder="City" formControlName="city"
                    (change)="onChangecity($event.target.value)" class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country != 'US'">
                  <input type="text" maxlength="11" (keypress)="digitKeyOnly($event)" placeholder="zipcode"
                    formControlName="zipCode" (change)="onChangezipcode($event.target.value)"
                    class="form-control input-sm" />
                </div>
                <div class="col-sm-6" *ngIf="jobFilterForm.value.country == 'US'">
                  <input type="text" maxlength="50" disabled placeholder="State" formControlName="state"
                    (change)="onChangestate($event.target.value)" class="form-control input-sm" />
                </div>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>

      <ngb-accordion>
        <ngb-panel id="custom-panel-7">
          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Experience (Years)</span>
                <span [ngClass]="getBadgeClass(1)" *ngIf="!orgJobsMode">
                  1
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                  [value]="EXPERIENCE_ANY" style="display: none;" type="radio" id="exampleRadio0">
                <label class="form-check-label custom-radio-label" for="exampleRadio0">
                  {{EXPERIENCE_ANY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                  [value]="EXPERIENCE_JUNIOR" style="display: none;" type="radio" id="exampleRadio1">
                <label class="form-check-label custom-radio-label" for="exampleRadio1">
                  {{EXPERIENCE_JUNIOR}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                  [value]="EXPERIENCE_MID_LEVEL" style="display: none;" type="radio" id="exampleRadio12">
                <label class="form-check-label custom-radio-label" for="exampleRadio12">
                  {{EXPERIENCE_MID_LEVEL}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                  [value]="EXPERIENCE_SENIOR" style="display: none;" type="radio" id="exampleRadio3">
                <label class="form-check-label custom-radio-label" for="exampleRadio3">
                  {{EXPERIENCE_SENIOR}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="experienceType" (change)="onExperienceValueChange()"
                  [value]="EXPERIENCE_ARCHITECT" style="display: none;" type="radio" id="exampleRadio4">
                <label class="form-check-label custom-radio-label" for="exampleRadio4">
                  {{EXPERIENCE_ARCHITECT}}
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>

      <ngb-accordion>
        <ngb-panel id="custom-panel-8">

          <ng-template ngbPanelHeader let-opened="opened">
            <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
              <button ngbPanelToggle class="filter-header-btn">
                <span class="card-header-title">Posted (Days)</span>
                <span [ngClass]="getBadgeClass(1)" *ngIf="!orgJobsMode">
                  1
                </span>
              </button>
              <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
                <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
              </button>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div class="col-sm-12">
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                  [value]="POSTED_ANY" style="display: none;" type="radio" id="exampleRadio00">
                <label class="form-check-label custom-radio-label" for="exampleRadio00">
                  {{POSTED_ANY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                  [value]="POSTED_TODAY" style="display: none;" type="radio" id="exampleRadio11">
                <label class="form-check-label custom-radio-label" for="exampleRadio11">
                  {{POSTED_TODAY}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                  [value]="POSTED_LAST_7_DAYS" style="display: none;" type="radio" id="exampleRadio44">
                <label class="form-check-label custom-radio-label" for="exampleRadio44">
                  {{POSTED_LAST_7_DAYS}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                  [value]="POSTED_LAST_14_DAYS" style="display: none;" type="radio" id="exampleRadio22">
                <label class="form-check-label custom-radio-label" for="exampleRadio22">
                  {{POSTED_LAST_14_DAYS}}
                </label>
              </div>
              <div class="custom-form-check">
                <input class="form-check-input" formControlName="postedDayRange" (change)="onPostedDaysChange()"
                  [value]="POSTED_LAST_30_DAYS" style="display: none;" type="radio" id="exampleRadio33">
                <label class="form-check-label custom-radio-label" for="exampleRadio33">
                  {{POSTED_LAST_30_DAYS}}
                </label>
              </div>
            </div>
          </ng-template>
        </ngb-panel>

      </ngb-accordion>


      <!-- <ngb-accordion #acc="ngbAccordion">
      </ngb-accordion>

      <ngb-accordion>
      </ngb-accordion>

      <ngb-accordion>
      </ngb-accordion>

      <ngb-accordion>

      </ngb-accordion>


      <ngb-accordion>

      </ngb-accordion>


      <ngb-accordion>

      </ngb-accordion> -->

      <app-common-skeleton *ngIf="isLoading"  [NameOftheScreen]="'verticalCheckboxSelection'"></app-common-skeleton>



    </div>




    <!-- The following code will be reused in the future once relevnt development patch is addressed -->
    <!-- <div class="row">
      <div class="col-sm-12 form-group">
        <div class="filter-title">
          <span>  Posted By
</span>
        </div>
      </div>
    </div>
    <div formGroupName="organisationTypeParams">
      <div class="col-sm-6">
        <div class="custom-checkbox" title="All">
          <label class="checkbox-label font-normal">
            <input type="checkbox" formControlName="all" (change)="onSelectCreatedBy($event,'all', 'horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp">All</p>
          </label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="custom-checkbox" title="Posted by owner">
          <label class="checkbox-label font-normal">
            <input type="checkbox" formControlName="owner" (change)="onSelectCreatedBy($event,'owner', 'horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp">Owner</p>
          </label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="custom-checkbox" title="Posted by Systems Integrator">
          <label class="checkbox-label font-normal">
            <input type="checkbox" formControlName="systemsIntergrator"
              (change)="onSelectCreatedBy($event,'systemsIntergrator','horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> Systems Integrator</p>
          </label>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="custom-checkbox" title="Posted by Prime Vendor">
          <label class="checkbox-label font-normal">
            <input type="checkbox" formControlName="primeVendor"
              (change)="onSelectCreatedBy($event,'primeVendor','horizontal')" />
            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> Prime Vendor</p>
          </label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="custom-checkbox" title="Posted by Vendor/ Staffing Agency">
          <label class="checkbox-label font-normal">
            <input type="checkbox" formControlName="vendorStaffingAgency"
              (change)="onSelectCreatedBy($event,'vendorStaffingAgency','horizontal')" />

            <span class="checkmark" style="top: -5px"></span>
            <p class="label-ppp"> Vendor/ Staffing Agency</p>
          </label>
        </div>
      </div>
    </div>
    <hr> -->


  </form>
</ng-container>
